import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeedThresholdComponent } from './speed-threshold.component';
import { MaterialModule } from "../../material/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SpeedThresholdComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule
],
  exports:[
    SpeedThresholdComponent
  ]
})
export class SpeedThresholdModule { }
